import { Component, OnInit } from '@angular/core';
import { ConteudoService } from '@core/services/conteudo.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-dash-updates',
  templateUrl: './dash-updates.component.html',
  styleUrls: ['./dash-updates.component.scss']
})
export class DashUpdatesComponent implements OnInit {

  novidades = [];

  constructor(private _conteudoService: ConteudoService) { }

  ngOnInit(): void {
    this._conteudoService.buscarNovidadesHome()
      .pipe(
        switchMap(resultado =>
          Array.isArray(resultado)
            ? this._conteudoService.buscarConteudosComImagens(resultado.slice(0, 4))
            : of([])
        )
      )
      .subscribe(novidades => {
        this.novidades = novidades;
      });
  }

}
